import { __awaiter } from "tslib";
import Vue from 'vue';
import { mapGetters } from 'vuex';
import moment from 'moment';
export default Vue.extend({
    name: 'commonConfirmEmailPopupChunk',
    props: {
        slotData: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        form: {
            fields: {
                emailCode: {
                    loading: false,
                    valid: false,
                    codeSendError: false,
                    codeIsSent: false,
                    codeSentBefore: false,
                    retryTimeout: 60,
                    retries: 3,
                    letRetry: false,
                    value: '',
                    rules: [
                        (v) => Boolean(v) || 'Поле обязательно'
                    ]
                }
            }
        }
    }),
    computed: Object.assign({}, mapGetters('user', ['getUserData'])),
    watch: {
        'form.fields.emailCode.retryTimeout'(v) {
            const vm = this;
            if (v > 0) {
                setTimeout(() => {
                    vm.form.fields.emailCode.retryTimeout = v - 1;
                }, 1000);
            }
            else
                vm.form.fields.emailCode.letRetry = true;
        }
    },
    methods: {
        sendEmail() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                vm.form.fields.emailCode.loading = true;
                vm.form.fields.emailCode.codeSentBefore = false;
                const response = yield vm.$services.sendCode(vm.slotData.codes.email);
                if (response.success) {
                    vm.form.fields.emailCode.loading = false;
                    vm.form.fields.emailCode.codeIsSent = true;
                    vm.form.fields.emailCode.letRetry = false;
                    vm.form.fields.emailCode.retryTimeout = moment(response.data.repeatAfter).diff(moment(), 'seconds');
                    vm.form.fields.emailCode.retries -= 1;
                    setTimeout(() => {
                        vm.form.fields.emailCode.retryTimeout -= 1;
                    }, 1000);
                }
                else {
                    vm.form.fields.emailCode.loading = false;
                    if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.repeatAfter) {
                        vm.form.fields.emailCode.codeSentBefore = true;
                        vm.form.fields.emailCode.codeIsSent = true;
                        vm.form.fields.emailCode.letRetry = false;
                        vm.form.fields.emailCode.retryTimeout = moment(response.data.repeatAfter).diff(moment(), 'seconds');
                        vm.form.fields.emailCode.retries -= 1;
                        setTimeout(() => {
                            vm.form.fields.emailCode.retryTimeout -= 1;
                        }, 1000);
                    }
                    else {
                        vm.form.fields.emailCode.codeSendError = true;
                        vm.form.fields.emailCode.letRetry = true;
                    }
                }
            });
        }
    }
});
